import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadInstitutionCode: IInstitutionCodeLoadActionCreator = () => {
        return {
            type: ACTION_INSTITUTIONCODE_LOAD
        }
    },
    LoadInstitutionCodeById: IInstitutionCodeLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_INSTITUTIONCODE_LOAD_BY_ID,
            id
        }
    },
    LoadInstitutionCodeByInstitutionId: IInstitutionCodeLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_INSTITUTIONCODE_LOAD_BY_INSTITUTIONID,
            institutionId
        }
    },
    LoadSuccess: IInstitutionCodeLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCODE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionCodeLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCODE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveInstitutionCode: IInstitutionCodeSaveActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONCODE_SAVE,
            formData
        }
    },
    SaveSuccess: IInstitutionCodeSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCODE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IInstitutionCodeSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCODE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateInstitutionCode: IInstitutionCodeCreateActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONCODE_CREATE,
            institutionId
        }
    },
    CreateSuccess: IInstitutionCodeCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_INSTITUTIONCODE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IInstitutionCodeCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCODE_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateInstitutionCode: IInstitutionCodeValidateActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONCODE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IInstitutionCodeValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCODE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IInstitutionCodeValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCODE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IInstitutionCodeClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTIONCODE_CLEAR,
            propertiesToClear
        }
    },

    Filter: IInstitutionCodeFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTIONCODE_FILTER,
            formFilter
        }
    };



export const
    ACTION_INSTITUTIONCODE_LOAD = "ACTION_INSTITUTIONCODE_LOAD",
    ACTION_INSTITUTIONCODE_LOAD_BY_ID = "ACTION_INSTITUTIONCODE_LOAD_BY_ID",
    ACTION_INSTITUTIONCODE_LOAD_BY_INSTITUTIONID = "ACTION_INSTITUTIONCODE_LOAD_BY_INSTITUTIONID",
    ACTION_INSTITUTIONCODE_LOAD_SUCCESS = "ACTION_INSTITUTIONCODE_LOAD_SUCCESS",
    ACTION_INSTITUTIONCODE_LOAD_FAILURE = "ACTION_INSTITUTIONCODE_LOAD_FAILURE",

    ACTION_INSTITUTIONCODE_SAVE = "ACTION_INSTITUTIONCODE_SAVE",
    ACTION_INSTITUTIONCODE_SAVE_SUCCESS = "ACTION_INSTITUTIONCODE_SAVE_SUCCESS",
    ACTION_INSTITUTIONCODE_SAVE_FAILURE = "ACTION_INSTITUTIONCODE_SAVE_FAILURE",

    ACTION_INSTITUTIONCODE_CREATE = "ACTION_INSTITUTIONCODE_CREATE",
    ACTION_INSTITUTIONCODE_CREATE_SUCCESS = "ACTION_INSTITUTIONCODE_CREATE_SUCCESS",
    ACTION_INSTITUTIONCODE_CREATE_FAILURE = "ACTION_INSTITUTIONCODE_CREATE_FAILURE",

    ACTION_INSTITUTIONCODE_VALIDATE = "ACTION_INSTITUTIONCODE_VALIDATE",
    ACTION_INSTITUTIONCODE_VALIDATE_SUCCESS = "ACTION_INSTITUTIONCODE_VALIDATE_SUCCESS",
    ACTION_INSTITUTIONCODE_VALIDATE_FAILURE = "ACTION_INSTITUTIONCODE_VALIDATE_FAILURE",

    ACTION_INSTITUTIONCODE_CLEAR = "ACTION_INSTITUTIONCODE_CLEAR",

    ACTION_INSTITUTIONCODE_FILTER = "ACTION_INSTITUTIONCODE_FILTER";

export interface IInstitutionCodeLoadAction {
    type: "ACTION_INSTITUTIONCODE_LOAD";
}

export interface IInstitutionCodeLoadActionCreator {
    (): IInstitutionCodeLoadAction;
}

export interface IInstitutionCodeLoadSuccessAction {
    type: "ACTION_INSTITUTIONCODE_LOAD_SUCCESS";
    formData: Dtos.InstitutionCode | Dtos.InstitutionCode[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionCodeLoadSuccessActionCreator {
    (
        formData: Dtos.InstitutionCode | Dtos.InstitutionCode[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionCodeLoadSuccessAction;
}

export interface IInstitutionCodeLoadFailureAction {
    type: "ACTION_INSTITUTIONCODE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionCodeLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionCodeLoadFailureAction;
}

export interface IInstitutionCodeLoadByIdAction {
    type: "ACTION_INSTITUTIONCODE_LOAD_BY_ID";
    id: number;
}

export interface IInstitutionCodeLoadByIdActionCreator {
    (id: number): IInstitutionCodeLoadByIdAction;
}

export interface IInstitutionCodeLoadByInstitutionIdAction {
    type: "ACTION_INSTITUTIONCODE_LOAD_BY_INSTITUTIONID";
    institutionId: number;
}

export interface IInstitutionCodeLoadByInstitutionIdActionCreator {
    (institutionId: number): IInstitutionCodeLoadByInstitutionIdAction;
}


export interface IInstitutionCodeSaveAction {
    type: "ACTION_INSTITUTIONCODE_SAVE";
    formData: Dtos.InstitutionCode;

}

export interface IInstitutionCodeSaveActionCreator {
    (
        formData: Dtos.InstitutionCode
    ): IInstitutionCodeSaveAction;
}

export interface IInstitutionCodeSaveSuccessAction {
    type: "ACTION_INSTITUTIONCODE_SAVE_SUCCESS";
    formData: Dtos.InstitutionCode;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionCodeSaveSuccessActionCreator {
    (
        formData: Dtos.InstitutionCode,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionCodeSaveSuccessAction;
}

export interface IInstitutionCodeSaveFailureAction {
    type: "ACTION_INSTITUTIONCODE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionCodeSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionCodeSaveFailureAction;
}

export interface IInstitutionCodeCreateAction {
    type: "ACTION_INSTITUTIONCODE_CREATE",
    institutionId
}

export interface IInstitutionCodeCreateActionCreator {
    (institutionId: number): IInstitutionCodeCreateAction
}

export interface IInstitutionCodeCreateSuccessAction {
    type: "ACTION_INSTITUTIONCODE_CREATE_SUCCESS";
    formData: Dtos.InstitutionCode;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IInstitutionCodeCreateSuccessActionCreator {
    (
        formData: Dtos.InstitutionCode,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IInstitutionCodeCreateSuccessAction;
}

export interface IInstitutionCodeCreateFailureAction {
    type: "ACTION_INSTITUTIONCODE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionCodeCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionCodeCreateFailureAction;
}

export interface IInstitutionCodeValidateAction {
    type: "ACTION_INSTITUTIONCODE_VALIDATE";
    formData: Dtos.InstitutionCode;

}

export interface IInstitutionCodeValidateActionCreator {
    (
        formData: Dtos.InstitutionCode
    ): IInstitutionCodeValidateAction;
}

export interface IInstitutionCodeValidateSuccessAction {
    type: "ACTION_INSTITUTIONCODE_VALIDATE_SUCCESS";
    formData: Dtos.InstitutionCode;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionCodeValidateSuccessActionCreator {
    (
        formData: Dtos.InstitutionCode,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionCodeValidateSuccessAction;
}

export interface IInstitutionCodeValidateFailureAction {
    type: "ACTION_INSTITUTIONCODE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionCodeValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionCodeValidateFailureAction;
}

export interface IInstitutionCodeClearAction {
    type: "ACTION_INSTITUTIONCODE_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionCodeClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionCodeClearAction;
}

export interface IInstitutionCodeFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionCodeFilterAction;
}

export interface IInstitutionCodeFilterAction {
    type: "ACTION_INSTITUTIONCODE_FILTER";
    formFilter: IFormFilter;
}

export type InstitutionCodeAction =
    IInstitutionCodeLoadAction |
    IInstitutionCodeLoadByIdAction |
    IInstitutionCodeLoadByInstitutionIdAction |
    IInstitutionCodeLoadFailureAction |
    IInstitutionCodeLoadSuccessAction |
    IInstitutionCodeSaveAction |
    IInstitutionCodeSaveSuccessAction |
    IInstitutionCodeSaveFailureAction |
    IInstitutionCodeCreateAction |
    IInstitutionCodeCreateSuccessAction |
    IInstitutionCodeCreateFailureAction |
    IInstitutionCodeValidateAction |
    IInstitutionCodeValidateSuccessAction |
    IInstitutionCodeValidateFailureAction |
    IInstitutionCodeFilterAction | 
    IInstitutionCodeClearAction;
